import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { IStore } from '../interfaces/Store'
import { triggerChangeForSelectInput } from '../services/utils'
import { IFolderContent } from '../interfaces/Folder'

export const useTriggerChangeHook = (prop: keyof IFolderContent): string => {
  const value = useSelector(
    (stateReducer: IStore) => stateReducer.folderReducer.folder[prop]
  ) as string

  useEffect(() => {
    if (value !== '') {
      triggerChangeForSelectInput(prop as string, value)
    }
  }, [value, prop])

  return value
}
